export default __webpack_public_path__ + "static/media/LogoVivezParis.05061b10.png";